import {
  BanknoteArrowUp,
  CalendarDays,
  CircleUserRound,
  FileUp,
  Handshake,
  MapPinned,
  Printer,
  Repeat,
  ScrollText,
  Send,
  SquareUser,
  Trophy,
  Upload,
    RefreshCw,
} from "lucide-react";
import { useEffect, useState } from "react";
import TransactionTab from "./transaction";
import ClientsTab from "./client";
import PropertiesTab from "./properties";
import {
  getAlldealforAdmin,
  getAllusers,
  getTaskTemplate,
  saveitemwithid,
  updateItem,
  uploadImagesToFirebase,
} from "../../utils/firebasefunctions";
import { useStateValue } from "../../context/StateProvider";
import { actionType } from "../../context/reducer";
import { Plus } from "lucide-react";
import BulkUploadDeals from "./BulkUploadDeals";
import AddNewDeal from "../home/add-deal";
import { toast } from "react-toastify";
import DeleteDeal from "./delete-deal";
import { getToken } from "firebase/messaging";
import { messaging } from "../../firebase/firebaseConfig";
import { arrayUnion } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { newmessagesuccess, notifyApprovers } from "../../utils/helper";
import PageHeader from "../PageHeader";
// import YearOver from "./year-over";
// import AgentProductionTab from "./agent-production";
// import RankingsSection from "./team-ranking";

function DealHero() {
  const [{ user, deals, steps, users }, dispatch] = useStateValue();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("transaction");
  const [isLoad, setIsLoad] = useState(false);
  const [bulkform, setbulkform] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tasks, setTasks] = useState({});
  const tabs = [
    { id: "transaction", label: "Transactions", icon: Repeat },
    { id: "client", label: "Clients", icon: SquareUser },
    { id: "properties", label: "Properties", icon: MapPinned },
  ];

  async function getalldeal() {
    await getAlldealforAdmin("deals")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_DEALS,
          deals: response,
        });
        setIsLoad(true);
      })
      .catch((err) => {
        alert(err);
      });
  }

  const columnIds = [
    "Prospect",
    "On Hold",
    "CMAs",
    "Listing Appointment",
    "Pre-Market",
    "Coming Soon",
    "Active",
    "Under Contract",
    "Pending",
    "Closed",
    "Cancelled",
    "Expired",
  ];

  const submitdeal = async (data, bool) => {
    let id = Date.now();
    setIsLoading(true);
    try {
      let imageUrls = [];

      if (data.step1.propertyphotofiles?.length > 0) {
        imageUrls = await uploadImagesToFirebase(data.step1.propertyphotofiles);
      }

      const selectedStage = data.step1.dealStage;

      const stageIndex = columnIds.indexOf(selectedStage);
      const allowedStages = columnIds.slice(0, stageIndex + 1);

      let allTasks = [];
      let taskStatusTracker = {};

      allowedStages.forEach((stage) => {
        const stageTasks = Array.isArray(tasks?.[stage]) ? tasks[stage] : [];

        // 🔥 tasks add karo
        allTasks = [...allTasks, ...stageTasks];

        // 🔥 tracker banao
        taskStatusTracker[stage] = true;
      });

      let newdata = {
        status: bool ? "Approved" : "Pending",
        requestType: "saleTurnIn",
        propertyphoto: imageUrls,
        dealtype: data.step2.clientType,
        customers: data.step2.clientinfo,
        // priority: data.step1.Priority,
        dealStage: data.step1.dealStage,
        financingType: data.step1.financingType,
        // listingPrice: data.step1.listingPrice,
        earnestMoney: data.step1.earnestMoney,
        // mlsNumber: data.step1.mlsNumber,
        offerPrice: data.step1.offerPrice,
        propertyType: data.step1.propertyType,
        agentCommission: data.step3.agentCommission,
        fixedagentcommission: data.step3.fixedagentcommission,
        agentData: data.step3.agentid,
        agentName: data.step3.agentName,
        brokeradminfee: data.step3.brokeradminfee,
        captype: data.step3.captype,
        captypedescription: data.step3.captypedescription,
        closingdate: data.step1.closingdate,
        inspection: data.step1.inspection,
        propertyLocation: data.step1.propertyLocation,
        inspectionDeadline: data.step1.inspectionDeadline,
        financingDeadline: data.step1.financingDeadline,
        leadCommission: data.step3.leadCommission,
        leadsource: data.step3.leadsource,
        propertyaddress: data.step1.propertyaddress,
        splitdescription: data.step3.splitdescription,
        splittype: data.step3.splittype,
        teamleadName: data.step3.teamleadName,
        flatfee: data.step4.flatfee,
        flatfeeamount: data.step4.flatfeeamount,
        assignedteamlead: data.step3.assignedteamlead,
        thirdpartyagentCommission: data.step3.thirdpartyagentCommission,
        thirdpartyagentName: data.step3.thirdpartyagentName,
        agentCommissionamount: data.step4.agentCommissionamount,
        bankcommission: data.step4.bankcommission,
        buyersidecommissionrate: data.step4.buyersidecommissionrate,
        leadsourceCommissionamount: data.step4.leadsourceCommissionamount,
        sellersidecommissionrate: data.step4.sellersidecommissionrate,
        takehomecommissionamount: data.step4.takehomecommissionamount,
        teamleadCommissionamount: data.step4.teamleadCommissionamount,
        teamleadcommissionrate: data.step4.teamleadcommissionrate,
        thirdpartyagentcommissionamount:
          data.step4.thirdpartyagentcommissionamount,
        totalCommissionamount: data.step4.totalCommissionamount,
        totalcommissionrate: data.step4.totalcommissionrate,

        createdby: user.id,
        createdat: id,
      };

      console.log(newdata);

      let result = await saveitemwithid("deals", id.toString(), newdata);

      if (result == "success") {
        allTasks.forEach((task) => {
          if (task?.assignee) {
            newmessagesuccess(
              "New Task Assigned",
              task.assignee?.id,
              task?.title || "",
              task.id || "",
              "newtask",
              newdata.createdat,
            );
          }
        });
        toast.success("Deal created successfully!");
        if (newdata.status === "Pending") {
          try {
            await notifyApprovers({ ...newdata, createdat: id }, users, user);
          } catch (notifyErr) {
            console.error("Failed to notify approvers:", notifyErr);
          }
        }
        setIsOpen(false);
        setIsLoading(false);
      } else {
        toast.error(result || "Failed to create deal");
        setIsLoading(false);
      }
    } catch (err) {
      toast.error(err.message);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getalldeal();
  }, []);

  useEffect(() => {
    if (user?.id) {
      if (user?.id != undefined) {
        requestPermission();
      }
    }
  }, [user]);

    useEffect(() => {
    const client = window.google.accounts.oauth2.initTokenClient({
      client_id:
        "627842934381-7bra6ha78jub716ceu9hq433chsh69dn.apps.googleusercontent.com",
      scope: "https://www.googleapis.com/auth/contacts.readonly",
      callback: (response) => {
        if (response.access_token) {
          fetchContacts(response.access_token);
        }
      },
    });

    window.loginWithGoogle = () => {
      client.requestAccessToken();
    };
  }, []);

    const fetchContacts = async (token) => {
    try {
      const res = await fetch(
        "https://us-central1-team-edelstein.cloudfunctions.net/api/getcontacts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: token,
          }),
        },
      );

      if (res.status === 200) {
        console.log("Successfully Retreived Contacts");
        const dataresponse = await res.json();
        console.log("All Contacts Backend " + JSON.stringify(dataresponse));
        let dataset = {
          contacts: dataresponse.data,
        };
        // await updateUserProfile(user.id, dataset);
        // const userInfo = await getuserinformation("users", user.id);
        // dispatch({ type: actionType.SET_USER, payload: userInfo });
        localStorage.setItem("sync-ontact", JSON.stringify(dataset));
        toast.success("Contacts Synced Successfully!");
      } else {
        toast.error("Syncing Failed");
        console.log("Authentication Error");
      }
    } catch (error) {
      toast.error("Authentication Error");
      console.error("Error:", error);
    }
  };


  async function requestPermission() {
    //requesting permission using Notification API
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BKNonFk-lAUXh-_LSJ6F1aoG1ZfVupq3qc3FsR2WgQw48IpnqLWRQ5MrYDqFzG4xNfAxovO6AB51e5lhp1JDG3Y",
      });

      //We can send token to server
      console.log("Token generated : ", token);
      if (
        user?.NotificationToken == undefined ||
        user?.NotificationToken?.find((data) => data == token) == undefined
      ) {
        updatenotificationtoken(token);
      }
    } else if (permission === "denied") {
      //notifications are blocked
      alert("You denied for the notification");
    }
  }

  const updatenotificationtoken = async (token) => {
    let data = {
      NotificationToken: arrayUnion(token),
    };
    await updateItem("users", user?.id, data)
      .then(async (response) => {})
      .catch((err) => {
        alert(err);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getTaskTemplate();
      setTasks(data || {});
      console.log("task templates", data);
    };

    fetchData();
  }, []);

  return (
    <main className="">
      <PageHeader title="Transactions" />

      {/* ===== Underline Tabs ===== */}
      <div className="px-6 border-b border-slate-200 bg-white">
        <div className="flex gap-1">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2.5 -mb-px border-b-2 text-sm font-semibold whitespace-nowrap transition ${
                  isActive
                    ? "border-indigo-500 text-indigo-700"
                    : "border-transparent text-slate-500 hover:text-slate-700"
                }`}
              >
                {tab.icon && <tab.icon className="w-4 h-4" />}
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="px-6 py-4">


        {/* ===== Tab Content ===== */}
        {activeTab === "transaction" && isLoad && (
          <TransactionTab deals={deals} />
        )}
        {activeTab === "client" && <ClientsTab deals={deals} />}
        {activeTab === "properties" && <PropertiesTab deals={deals} />}
        {/* {activeTab === "commission" && (
          <div className="bg-white p-6 rounded-2xl shadow-sm text-center text-gray-500">
            Commission Analysis Reports coming soon...
          </div>
        )} */}
        {bulkform && (
          <BulkUploadDeals
            // isLoading={isLoading}
            onClose={() => setbulkform(false)}
            onSubmit={(data) => {
              alert(data);
            }}
          />
        )}
      </div>
      {isOpen && (
        <AddNewDeal
          isLoading={isLoading}
          onClose={() => setIsOpen(false)}
          onSubmit={(data, bool) => {
            submitdeal(data, bool);
          }}
          steps={steps}
        />
      )}
    </main>
  );
}

function ToolbarButton({ icon: Icon, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 hover:border-slate-300 transition"
    >
      {Icon && <Icon size={14} />}
      <span>{label}</span>
    </button>
  );
}

export default DealHero;
